// extracted by mini-css-extract-plugin
export default {"form":"-vuG385N_9"};